import { keys, values, zipWith, flow, assign } from "lodash/fp";
import { toObject } from "../../core/utils";

class ContractorPageTransform {
  constructor() {
    "ngInject";

    this.item = {
      title: "Captain",
      state: "captain",
      name: "captain",
    };

    this.captainFields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "Phone", name: "phone" },
      { title: "Status", name: "status" },
      { title: "Rating", name: "rating", isSortable: true },
    ];

    this.invoiceFields = [
      { name: "contractor", title: "Contractor" },
      { name: "status", title: "Status" },
      { name: "start_date", title: "Start Date" },
      { name: "end_date", title: "End Date" },
      { name: "total_amount", title: "Total Amount" },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.is_tax_filer = { name: item.is_tax_filer };
      item.extraInfo = this.justifyExtraInfo(item.extra_info);
      item.name_i18n = { ...item.name_i18n, isDisabled: true };
      item.captains = toObject(item.captains);
      item.owner = toObject(item.owner);

      return item;
    };

    const formatDocuments = (item) => {
      const documentsData = {};
      documentsData.owner = item.owner || {};
      documentsData.owner.national_id = assign(
        { isDisabled: true },
        documentsData.owner.national_id
      );
      documentsData.documents = item.documents || {};
      documentsData.documents.commercial_registration = assign(
        { isDisabled: true },
        documentsData.documents.commercial_registration
      );
      documentsData.documents.insurance_number = assign(
        { isDisabled: true },
        documentsData.documents.insurance_number
      );
      documentsData.documents.tax_number = assign(
        { isDisabled: true },
        documentsData.documents.tax_number
      );

      item.documentsData = documentsData;

      return item;
    };

    data.managers = data.managers || [];

    return flow([formatDocuments, format, toObject])(data);
  }

  justifyExtraInfo(info) {
    const infoKeys = keys(info);
    const infoValues = values(info);

    return zipWith((key, value) => ({ key, value }), infoKeys, infoValues);
  }
}

export default ContractorPageTransform;



// WEBPACK FOOTER //
// ./src/pages/contractor/contractor.transforms.js